<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm align-items-center text-sm d-flex justify-content-between catalogo-text"
          >
            Puesto
            <router-link :to="{ name: 'Puestos' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>
          <CCardBody v-if="isLoadingPage">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>
          <CCardBody v-else>
            <CRow>
              <CCol sm="9" md="9" lg="9">
                <CInput
                  :value.sync="$v.nombrePuesto.$model"
                  :isValid="checkIfValid('nombrePuesto')"
                  label="Nombre del puesto:"
                  placeholder="Nombre..."
                  invalidFeedback="Campo requerido"
                />
              </CCol>
            </CRow>
            
            <ExtraConfigInput
              title="del puesto"
              parametro="puestos_atributos_extras"
              v-model="fieldsExtra"
              @config="config => fieldsExtraConfig = config"
              @onValid="v=>valid=v"
            />
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Puestos' }">
              <CButton class="px-4 mx-3 btn-lg" color="danger">Cancelar</CButton>
            </router-link>
            <CButton @click="addPuesto()" class="px-4 mx-3 btn-lg" color="success">
              <div v-if="isLoading">
                <div class="w-100 d-flex justify-content-center align-items-center">
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
              <span v-else>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
      <CModal
        size="sm"
        title="Puesto"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
      >{{ error }}</CModal>
    </CRow>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import ExtraConfigInput from './../../customComponents/ExtraConfigInput.vue'


export default {
  name: "EditarPuesto",
  components: {
    ExtraConfigInput,
  },

  data() {
    return {
      id: this.$route.params.id,
      nombrePuesto: "",
      item: {},
      warningModal: false,
      error: "",
      fieldsExtraConfig: [],
      fieldsExtra: {},
      details: [],
      itemModal: { id: "", name: "" },
      isLoading: false,
      isLoadingPage: false,
      valid: {flag: true}
    };
  },

  mixins: [validationMixin],
  validations: {
    nombrePuesto: {
      required
    }
  },

  created() {
    console.log(this.id);
    this.isLoadingPage = true;

    this.$store
      .dispatch("customHTTP", {
        schema: "puestos",
        filter: {
          where: [
            {
              field: "id",
              value: this.id,
              operator: "="
            }
          ]
        }
      })
      .then(res => {
        this.item = res.data[0];
        console.log(this.item.payload.nombre);
        this.nombrePuesto = this.item.payload.nombre;
        if(this.item.payload.extras !== undefined){
          let fieldsExtraPayload = Object.entries(this.item.payload.extras);
          for (let index = 0; index < fieldsExtraPayload.length; index++) {
            const fieldExtra = fieldsExtraPayload[index];
            this.fieldsExtra[fieldExtra[0]] = fieldExtra[1]
          }
        }
      })
      .finally(() => (this.isLoadingPage = false));
  },

  computed: {
    isValidPuesto() {
      return !this.$v.nombrePuesto.$invalid;
    }
  },

  methods: {
    addPuesto() {
      this.validatePuesto();

      if(!this.valid.flag){
        const valores = this.valid.valores
        this.error = `Son requeridos los campos: ${valores.join(', ')}`;
        this.warningModal=true
        return
      }
      if (this.isValidPuesto) {
        this.isLoading = true;

        // clean numbers extra fileds

        this.fieldsExtraConfig.forEach(indexField => {
          if (indexField.tipo === "number") {
            this.fieldsExtra[indexField.nombre] =
              Number(this.fieldsExtra[indexField.nombre]) || 0;
          }
          if (indexField.tipo === "text") {
            this.fieldsExtra[indexField.nombre] =
              this.fieldsExtra[indexField.nombre] || "";
          }
        });


        const agregarPuestos = {
            schema: "puestos",
            id: this.id,
            payload: {
              nombre: this.nombrePuesto
            }
          }

        if (this.fieldsExtraConfig.length > 0) {
          agregarPuestos.payload.extras = this.fieldsExtra;
        }

        this.$store
          .dispatch("customActualizarHTTP", agregarPuestos)
          .then(() => {
            // console.log(res.data);
            this.$router.push({ name: "Puestos" });
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
          })

          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validatePuesto() {
      this.$v.nombrePuesto.$touch();
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
